import React from 'react';
import { Form2Data } from '../types';

interface Step4Props {
    teilnahme: Form2Data['teilnahme'];
}

const Step4Confirmation: React.FC<Step4Props> = ({ teilnahme }) => {
    const message = teilnahme === 'ja'
        ? "Vielen Dank für Ihre Anmeldung zum Limbach Jahresauftakt 2026!"
        : "Schade, dass Sie nicht teilnehmen können. Ihre Abmeldung wurde registriert.";

    return (
        <div className="max-w-4xl mx-auto bg-white p-6 md:p-8 rounded-lg shadow-lg text-center">
            <div className="flex justify-center items-center mb-4">
                <svg className="h-16 w-16 text-green-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
            </div>
            <p className="text-xl font-semibold text-gray-800">{message}</p>
            <p className="text-gray-600 mt-2">Bei Rückfragen kontaktieren Sie bitte <a className="text-magenta hover:underline" href="mailto:support@limbach-jahresauftakt.de">support@limbach-jahresauftakt.de</a>.</p>
        </div>
    );
};

export default Step4Confirmation;
